import React from 'react';

export default function ({messages, callback}) {
    return Object.keys(messages).map(function (key) {
        const {email, message} = messages[key];
        return (
            <li className="list-group-item" key={key}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-1">EMAIL:</div>
                        <div className="col-md-10 offset-1">{email}</div>
                        <div className="col-md-1 mt-1">MENSAJE:</div>
                        <div className="col-md-10 offset-1 mt-1">{message}</div>
                        <div className="col-md-1 btn-danger offset-11 mt-2" onClick={()=>callback(key)}>Borrar</div>
                    </div>
                </div>
            </li>
        );
    });
}




// WEBPACK FOOTER //
// ./src/admin/components/dashboard/MessagesList.js